import React, { Component } from 'react';
import Redirect from 'components/Redirect';
import { string } from 'prop-types';

import SmallButton from '@johnlewispartnership/wtr-ingredients/ingredients/SmallButton';
import { Close as CloseIcon } from '@johnlewispartnership/wtr-ingredients/foundations/icons';
import { AddAddress } from 'components/Address';

import styles from './AddressRouted.scss';

export default class AddressRouted extends Component {
  static propTypes = {
    lastLocation: string.isRequired,
  };

  constructor() {
    super();
    this.state = { redirect: false };
  }

  render() {
    const { redirect } = this.state;
    const { lastLocation } = this.props;

    if (redirect) {
      return <Redirect to={lastLocation} replace />;
    }

    return (
      <section className={styles['address-form']}>
        <div className={styles['close-button']}>
          <SmallButton
            aria-label="Close button"
            data-test="close-address-form-button"
            width="fit"
            startIcon={<CloseIcon />}
            onClick={() => this.setState({ redirect: true })}
          />
        </div>
        <AddAddress {...this.props} onAfterSubmit={() => this.setState({ redirect: true })} />
      </section>
    );
  }
}
